export default "__VITE_ASSET__1274007e__"